import { v7 } from 'uuid'
import { z } from 'zod'

export const DefaultSchema = z.object({
    id: z.string().default(() => {
        return v7()
    }),
    created_at: z.coerce.date().default(() => new Date()),
    updated_at: z.coerce.date().default(() => new Date()),
    deleted_at: z.optional(z.coerce.date())
})